import request from './request';
import { updateGlobalResources, getGlobalResources, setCache ,getCache} from '../utils/globalState';
import { data } from 'react-router-dom';

// 导出一个全局数组，用于记录已处理的 AI 请求及其结果
export const processingAIs: any[] = [];

// 简单的2秒缓存：改为使用 localStorage 存取，跨刷新可复用
const CACHE_TTL_MS = 2000;

// 将 inflight 提升为全局单例，避免多次初始化
const INFLIGHT_GLOBAL_KEY = '__GiftMkr_inflight__';
const inflight: Map<string, Promise<any>> =
  (globalThis as any)[INFLIGHT_GLOBAL_KEY] ?? new Map<string, Promise<any>>();
(globalThis as any)[INFLIGHT_GLOBAL_KEY] = inflight;

/**
 * 入参为序列化后的data字符串（例如 JSON.stringify(data)）。
 * 如果2秒内相同字符串再次调用，直接返回上次请求结果。
 */
export async function requestAIWithCache(dataStr: string): Promise<any> {
  const now = Date.now();  
  // 命中2秒缓存
  const cached = getCache(dataStr); 
  if (cached && cached.response.status=="completed") { 
    return cached.response;
  }
  if (cached && now - cached.timestamp <= CACHE_TTL_MS) {
    return cached.response;
  } 
  // 如果有正在进行的同key请求，复用它
  const existing = inflight.get(dataStr);
  if (existing) {
    return existing;
  }
 
  // 将字符串转换为请求payload
  let payload: any = undefined;
  try {
    payload = JSON.parse(dataStr);
  } catch (e) {
    // 如果不是JSON字符串，直接作为原始数据传递（兼容性处理）
    payload = dataStr as any;
  }
 
  // 先登记进行中的请求，避免并发情况下重复触发
  const p = new Promise<any>(async (resolve, reject) => {
    try {
      const res = await request({
        url: '../back/giftmkr/ai/requestAI',
        method: 'POST',
        data: payload,
      }); 
      setCache(dataStr, { timestamp: Date.now(), response: res.result }); 
      // 记录本次已处理的 AI 请求，方便其他模块引用
      if (res.result.status=="pending" || res.result.status=="processing") {
        const exists = processingAIs.some(it => it.key === dataStr); 
        if (!exists) { 
          processingAIs.push({"key":dataStr,"timestamp":Date.now(), "res":res.result});
        }
      } else if (res.result.status=="completed") { 
        const initialResources = [
          {
            id: `ai-${Date.now()}`,
            type: 'image' as const,
            content: res?.result?.url,
            aiUrl :res?.result?.src,
            name: 'URL Image',
            ai:res?.result?.code,
            focus:true,
            order: 1
          }
        ]; 
        let resources = getGlobalResources();
        resources = [...initialResources, ...resources];
        updateGlobalResources(resources); 
      }
      resolve(res.result);
    } catch (err) {
      reject(err);
    } finally {
      inflight.delete(dataStr);
    }
  });

  inflight.set(dataStr, p);
  return p;
}

export default requestAIWithCache;